/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.19",
    versionName: "0.2.0-nightly.2026.2.19",
    versionChannel: "nightly",
    buildDate: "2026-02-19T00:14:34.192Z",
    commitHash: "ae25866a3289d1e63f9ebb68128a39c03eaf8f0f",
};
